module.exports = __webpack_public_path__ + "static/media/salesforce.f7e14f3d.svg";